import AxiosConfig from '@/config/axios-config'

export const AssinaturaAPI = {

  listar (pagina, filtro) {
    return AxiosConfig.jalekoAPI().get('/admin/assinaturas',
      {
        params: {
          page: pagina,
          busca: filtro.busca,
          plano_macro_id: filtro.plano_macro_id,
          duracao_id: filtro.duracao_id,
          status_assinatura_id: filtro.status_assinatura_id,
          gateway_id: filtro.gateway_id,
          criado_por: filtro.criado_por,
          tipo_assinatura_id: filtro.tipo_assinatura_id,
          validade: filtro.validade,
          data_criacao_inicio: filtro.createdDate ? filtro.createdDateRange.startDate : '',
          data_criacao_fim: filtro.createdDate ? filtro.createdDateRange.endDate : '',
          data_validade_inicio: filtro.validDate ? filtro.validDateRange.startDate : '',
          data_validade_fim: filtro.validDate ? filtro.validDateRange.endDate : ''
        }
      }).then(response => response.data.assinaturas)
  },

  listarTipos () {
    return AxiosConfig.secureJalekoAPI().get('/admin/assinaturas/tipos').then(response => response.data.tipos_assinaturas)
  },

  listarStatus () {
    return AxiosConfig.secureJalekoAPI().get('/admin/assinaturas/status').then(response => response.data.status_assinaturas)
  },

  listarGateway () {
    return AxiosConfig.secureJalekoAPI().get('/admin/assinaturas/gateways').then(response => response.data.gateways)
  },

  listarResponsavel () {
    return AxiosConfig.secureJalekoAPI().get('/admin/assinaturas/responsaveis').then(response => response.data.responsaveis)
  },

  editaAssinatura (assinatura) {
    return AxiosConfig.secureJalekoAPI().put('/admin/assinaturas/cancelar', assinatura).then(response => response)
  },

  gerarBoletoAvulso (assinatura) {
    return AxiosConfig.secureJalekoAPIPagamentos().post('/api/assinaturas/boleto', assinatura).then(response => response.data)
  },

  validaCupom (cupom) {
    return AxiosConfig.secureJalekoAPIPagamentos().post('/api/cupom/valida', cupom).then(response => response)
  },

  buscaAssinaturaMundipagg (code, email) {
    return AxiosConfig.secureJalekoAPIPagamentos().get('/api/assinaturas/gateway', {
      params: { code: code, email: 'admin' }
    }).then(response => response.data)
  }

}

export default AssinaturaAPI
